
import { Vue, Component, Prop } from "vue-property-decorator";

import DELETE_MANAGERS_ACCESSED_CONTRACTOR from "@/apollo/managers/DeleteManagersAccessedContractor.gql";

import UiButton from "@/components/button/ui-button.vue";

import Message from "@/data/notificationsMessages";

import { NOTIFICATION } from "@/entities/Events";

@Component({
  components: {
    UiButton,
  },
})
export default class RemoveAccessToContractor extends Vue {
  @Prop({ type: String, required: true }) readonly managerContractorId!: string;
  @Prop({ type: String, required: true }) readonly contractorFullName!: string;

  processing: boolean = false;

  async removeAccess(): Promise<void> {
    if (this.processing) {
      return;
    }

    this.$confirm({
      title: `Remove access to ${this.contractorFullName}`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          await this.removeManagerAccessToContractor(this.managerContractorId);
        }
      },
    });
  }

  async removeManagerAccessToContractor(
    managerContractorId: string
  ): Promise<void> {
    this.processing = true;

    try {
      await this.removeAccessToContractor(managerContractorId);

      this.processing = true;

      this.$emit("accessRemoved");

      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`Access is removed`)
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }

  removeAccessToContractor(managerContractorId: string) {
    return this.$apollo.mutate({
      mutation: DELETE_MANAGERS_ACCESSED_CONTRACTOR,
      variables: { id: managerContractorId },
    });
  }
}
